import { useTheme } from '../../theme/ThemeContext';
function resolveButtonColor({
  isDisabled,
  isSelected,
  theme
}) {
  if (isDisabled) return theme.colors.textDisabled;
  if (isSelected) return theme.colors.primary;
  return theme.colors.text;
}
function resolveBorderColor({
  isDisabled,
  isSelected,
  theme
}) {
  if (isDisabled) return theme.colors.borderLight;
  if (isSelected) return theme.colors.primary;
  return theme.colors.borderLight;
}
export const useOptionButtonStyles = ({
  isDisabled,
  isSelected
}) => {
  const theme = useTheme();
  return {
    buttonStyle: {
      display: 'block',
      width: '100%',
      padding: '8px 16px',
      borderRadius: theme.components.button.borderRadius,
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      fontSize: theme.fontSizes.md,
      fontWeight: isSelected && !isDisabled ? theme.fontWeights.bold : theme.fontWeights.normal,
      textAlign: 'center',
      background: theme.colors.background,
      border: `1px solid ${resolveBorderColor({
        isDisabled,
        isSelected,
        theme
      })}`,
      color: resolveButtonColor({
        isDisabled,
        isSelected,
        theme
      })
    }
  };
};